<script>
export default {
  name: "CanceledView",
  beforeMount() {
    this.$trackEvent("returned_from_stripe");
    this.$router.push("/account?tab=subscription");
  },
};
</script>

<template>
  <eg-b-container>
    <section>
      <eg-b-row>
        <eg-b-col>
          <eg-b-alert variant="danger" show>
            We could not successfully charge your card. Ensure all your card
            information is up-to-date. Please try again.
          </eg-b-alert>
          <p>
            {{ $t("account.paymentFailed") }}
            <a href="mailto:hello@essaygrader.ai">hello@essaygrader.ai</a>
          </p>
          <eg-b-button to="/account" variant="info">{{
            $t("account.upgrade")
          }}</eg-b-button>
        </eg-b-col>
      </eg-b-row>
    </section>
  </eg-b-container>
</template>
